<script>
    export let acompanhamentos;
    const num_columns = 4;
    let total_items = acompanhamentos.acompanhamentos.length;
    let module = total_items % num_columns;
    let qty_by_column = total_items / num_columns;

    let columns = [];
    let accumulated = 0;
    for (let i = 0; i < num_columns; i++) {
        let qty_of_items_in_column =
            i < module ? Math.ceil(qty_by_column) : Math.floor(qty_by_column);
        columns.push(
            acompanhamentos.acompanhamentos.slice(
                accumulated,
                accumulated + qty_of_items_in_column
            )
        );
        accumulated = accumulated + qty_of_items_in_column;
    }
</script>

<style>
    .acompanhamentos {
        border-top: 1px solid #eee;
        padding-top: 100px;
        padding-bottom: 50px;
        font-family: "Poppins", sans-serif;
    }

    .acompanhamentos p {
        color: #f42f2c;
        font-size: 14px;
    }

    .title h1 {
        font-weight: 600;
        padding-bottom: 40px;
    }

    @media (max-width: 991.98px) {
        .title h1 {
            font-size: 30px !important;
            font-weight: 600;
            padding-bottom: 40px;
        }
    }

    .single-feature {
        padding-left: 60px;
    }
</style>

<main>
    <section id="acompanhamentos" class="acompanhamentos">
        <div class="title text-center">
            <h1>{acompanhamentos.titulo}</h1>
        </div>
        <div class="row">
            {#each columns as column}
                <div class="single-feature col-lg-3 col-md-6">
                    {#each column as value}
                        <p><b>{value}</b></p>
                    {/each}
                </div>
            {/each}
        </div>
    </section>
</main>
